<template>
  <ImageCard
    class="content-card"
    :src="src"
    :fixedHeight="fixedHeight"
    :tag="tag"
  >
    <div class="pellet text9" v-if="date">
      <FontIcon name="ui_hour" /> {{ date }}
    </div>
    <div class="header">
      <div class="infos">
        <div class="content-card-title text7">{{ title }}</div>
        <div class="subtitle text8" v-if="subtitle" v-html="subtitle"></div>
      </div>
      <div v-if="logo" class="header__logo">
        <img :src="logo" :alt="title" />
      </div>
    </div>
    <div
      class="content-card-description text5"
      v-if="description"
      v-html="description"
    ></div>
  </ImageCard>
</template>

<style lang="scss">
.content-card {
  .pellet {
    height: rem(28px);
    border-radius: rem(90px);
    position: absolute;
    right: 0;
    top: rem(-14px);
    @include setColor(--color-background1, background-color);
    @include setColor(--color-text);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 rem(10px);

    .font-icon {
      font-size: rem(12px);
      margin-right: 5px;
    }
  }

  .header {
    display: flex;
    margin-top: rem(10px);

    .infos {
      flex: 1;
    }

    .content-card-title {
      @include setColor(--color-title1);
    }

    .subtitle {
      min-height: rem(38px);
      @include setColor(--color-subtitle);
    }

    &__logo {
      display: flex;
      justify-content: right;
      align-items: center;
      width: rem(80px);
      height: rem(44px);

      img {
        object-fit: cover;
        max-height: 100%;
        height: auto;
        max-width: 100%;
        width: auto;
      }
    }
  }

  .content-card-description {
    @include setColor(--color-highlight);
  }

  .content {
    min-height: rem(66px);
  }
}
</style>

<script>
import FontIcon from "../../FontIcon/FontIcon";
import ImageCard from "../ImageCard/ImageCard";

export default {
  name: "ContentCard",

  components: {
    ImageCard,
    FontIcon,
  },

  props: {
    src: {
      type: String,
      default: null,
    },
    logo: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: null,
    },
  },
};
</script>
